package link.erpango.quip.utils

actual fun Double.format(digits: Int): String {
    return this.asDynamic().toFixed(digits) as String
}
